import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { ButtonGroup, Button, styled } from "@mui/material";
import { addToCart } from "../redux/actions/cartActions";
import { Navigate as navigate } from "react-router-dom";

const Component = styled(ButtonGroup)`
    margin-top: 30px;
`;

const StyledButton = styled(Button)`
    border-radius: 50%;
`;

const GroupedButton = ({item}) => {
    const [ counter, setCounter ] = useState(1);
    console.log(item)
    const {id}=item;
    const{quantity}=item;
    console.log(id);
      const dispatch = useDispatch();


    const addItemToCart = (id,quantity) => {
        dispatch(addToCart(id, quantity));
          navigate('/cart');
    }

    const handleIncrement = (id,quantity) => {
        const newQty = quantity + 1;
        setCounter(counter=>counter+1);
        dispatch(addItemToCart(id, newQty));
    };

    const handleDecrement = (id,quantity) => {
        const newQty = quantity - 1;
        if (quantity <= 1) return;
        setCounter(counter=>counter-1);
        dispatch(addItemToCart(id, newQty));
        setCounter(counter => counter - 1 );
    };

    return (
        <Component>
            <StyledButton onClick={() => handleDecrement(id,quantity)} disabled={counter == 0}>-</StyledButton>
            <Button disabled>{counter}</Button>
            <StyledButton onClick={() => handleIncrement(id,quantity)}>+</StyledButton>
        </Component>
    );
}  

export default GroupedButton;